import {
  Component,
  HostListener,
  Inject,
  Input, NgZone,
  OnInit, PLATFORM_ID
} from '@angular/core';
import {DOCUMENT, isPlatformBrowser} from "@angular/common";

@Component({
    selector: 'app-page-template',
    templateUrl: './page-template.component.html',
    styleUrls: ['./page-template.component.scss'],
    standalone: false
})
export class PageTemplateComponent implements OnInit {
  @Input() showBreadcrumbs: boolean = true;
  @Input() displayLargeMobileFooter: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() isLanding: boolean = false;
  @Input() isTopBannerVisible: boolean = false;
  @Input() slateBackground: boolean = true;
  @Input() showPageHeader: boolean = true;
  currentWindowWidth: number = 0;
  showHeader: boolean = true;
  contentHeight: string = '100vh';

  constructor(@Inject(DOCUMENT) private document: Document, @Inject(PLATFORM_ID) private platformId: Object, private ngZone: NgZone) {
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  ngOnInit(): void {
    if (this.document.location.href.includes("admin")) {
      this.showHeader = false;
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.updateContentHeight();

        const footer = document.querySelector('app-footer');
        if (footer) {
          const observer = new ResizeObserver(() => {
            this.ngZone.run(() => this.updateContentHeight());
          });
          observer.observe(footer);
        }
      });
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.currentWindowWidth = event.target.innerWidth;
    this.updateContentHeight();
  }

  private updateContentHeight(): void {
    if (isPlatformBrowser(this.platformId)) {
      const footer = document.querySelector('app-footer') as HTMLElement;
      if (footer) {
        const footerHeight = footer.offsetHeight;
        this.contentHeight = `calc(100vh - ${footerHeight}px)`;
      }
    }
  }
}
